export default "__VITE_ASSET__f_09D60x__"